// 获取还款记录列表
export const SET_REPAY_RECORD_LIST = 'SET_REPAY_RECORD_LIST'
// 设置详情
export const SET_NO_REPAY_DETAIL = 'SET_NO_REPAY_DETAIL'
// 获取金额
export const GET_NO_REPAY_DETAIL = 'GET_NO_REPAY_DETAIL'
// 获取还款详情
export const GET_REPAY_PLAN_INFO = 'GET_REPAY_PLAN_INFO'



// WEBPACK FOOTER //
// ./src/vuex/types/personaCenter/repaymentInfo.js